import { Controller } from "@hotwired/stimulus"

// Gestisce l'aggiunta/rimozione dinamica delle date di un corso (event_sessions nested).
export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()
    // Sostituisce l'indice placeholder con uno univoco (timestamp)
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString())
    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-session-row]")
    if (!row) return

    const destroyField = row.querySelector("input[name*='_destroy']")
    if (destroyField) {
      // Record esistente: marca per l'eliminazione e nascondi la riga
      destroyField.value = "1"
      row.style.display = "none"
    } else {
      // Riga nuova: rimuovi dal DOM
      row.remove()
    }
  }
}
